export default __webpack_public_path__ + "static/media/button_align_center.3cd5e657.svg";